<template>
  <div class="oracle-admin-layout">
    <!-- 오라클 스타일 헤더 -->
    <header class="oracle-header">
      <!-- 상단 유틸리티 바 -->
      <div class="header-utility-bar">
        <div class="utility-left">
          <span class="system-status">
            <i class="bi bi-circle-fill status-dot"></i>
            시스템 정상 운영중
          </span>
        </div>
        <div class="utility-right">
          <span class="current-time">
            <i class="bi bi-clock"></i>
            {{ currentTime }}
          </span>
          <span class="admin-name">
            <i class="bi bi-person-circle"></i>
            관리자
          </span>
          <button class="utility-btn" @click="logout">
            <i class="bi bi-box-arrow-right"></i>
            로그아웃
          </button>
        </div>
      </div>

      <!-- 메인 헤더 -->
      <div class="header-main">
        <div class="header-brand">
          <router-link to="/admin" class="brand-link">
            <div class="brand-icon">
              <i class="bi bi-layers-fill"></i>
            </div>
            <div class="brand-text">
              <span class="brand-title">Doctor Market</span>
              <span class="brand-subtitle">Admin Console</span>
            </div>
          </router-link>
        </div>

        <!-- 메인 네비게이션 -->
        <nav class="header-nav">
          <div class="nav-items">
            <a
              v-for="(menu, index) in mainMenus"
              :key="index"
              href="#"
              class="nav-item"
              :class="{ active: activeMenu === menu.id }"
              @click.prevent="setActiveMenu(menu)"
            >
              <i :class="menu.icon"></i>
              <span>{{ menu.name }}</span>
            </a>
          </div>
        </nav>

        <!-- 모바일 메뉴 토글 -->
        <button class="mobile-menu-toggle" @click="toggleMobileMenu">
          <i class="bi bi-list"></i>
        </button>
      </div>

      <!-- 모바일 메뉴 -->
      <div class="mobile-nav" :class="{ 'show': showMobileMenu }">
        <a
          v-for="(menu, index) in mainMenus"
          :key="'mobile-' + index"
          href="#"
          class="mobile-nav-item"
          :class="{ active: activeMenu === menu.id }"
          @click.prevent="setActiveMenu(menu); showMobileMenu = false"
        >
          <i :class="menu.icon"></i>
          <span>{{ menu.name }}</span>
        </a>
      </div>
    </header>

    <!-- 메인 컨테이너 -->
    <div class="oracle-main-container">
      <!-- 사이드바 -->
      <aside class="oracle-sidebar">
        <div class="sidebar-header">
          <i :class="getActiveMenuIcon()"></i>
          <span>{{ getActiveMenuName() }}</span>
        </div>
        <nav class="sidebar-nav">
          <router-link
            v-for="(subMenu, index) in getSubMenus()"
            :key="index"
            :to="subMenu.path"
            class="sidebar-link"
            active-class="active"
          >
            <i :class="subMenu.icon"></i>
            <span>{{ subMenu.name }}</span>
            <i class="bi bi-chevron-right arrow-icon"></i>
          </router-link>
        </nav>
        <div class="sidebar-footer">
          <div class="quick-stats">
            <div class="stat-item">
              <i class="bi bi-speedometer2"></i>
              <span>빠른 접근</span>
            </div>
          </div>
        </div>
      </aside>

      <!-- 메인 콘텐츠 -->
      <main class="oracle-content">
        <div class="content-wrapper">
          <router-view />
        </div>
      </main>
    </div>

    <!-- 푸터 -->
    <footer class="oracle-footer">
      <div class="footer-content">
        <div class="footer-left">
          <div class="footer-brand">
            <i class="bi bi-layers-fill"></i>
            <div class="footer-brand-text">
              <span class="footer-title">Doctor Market ERP</span>
              <span class="footer-subtitle">Enterprise Resource Planning</span>
            </div>
          </div>
        </div>
        <div class="footer-center">
          <div class="footer-status">
            <div class="status-badge online">
              <i class="bi bi-shield-check"></i>
              <span>보안 연결</span>
            </div>
            <div class="status-badge">
              <i class="bi bi-hdd-stack"></i>
              <span>서버 정상</span>
            </div>
            <div class="status-badge version">
              <span>v2.1.0</span>
            </div>
          </div>
        </div>
        <div class="footer-right">
          <div class="footer-links">
            <a href="#">도움말</a>
            <a href="#">문의하기</a>
            <a href="#">이용약관</a>
          </div>
          <p class="copyright">© 2024 Doctor Market. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'AdminLayout',
  data() {
    return {
      activeMenu: 'config',
      showMobileMenu: false,
      currentTime: '',
      mainMenus: [
        { id: 'config', name: '환경설정', icon: 'bi bi-gear' },
        { id: 'vendor', name: '거래처관리', icon: 'bi bi-building' },
        { id: 'seller', name: '입점사관리', icon: 'bi bi-shop' },
        { id: 'product', name: '제품관리', icon: 'bi bi-box' },
        { id: 'inventory', name: '재고관리', icon: 'bi bi-stack' },
        { id: 'shoporders', name: '주문관리', icon: 'bi bi-cart' },
        { id: 'promotion', name: '프로모션/쿠폰', icon: 'bi bi-tags' },
        { id: 'design', name: '디자인관리', icon: 'bi bi-palette' },
        { id: 'payment', name: '정산 및 외상결제관리', icon: 'bi bi-credit-card' },
        { id: 'stats', name: '매출/통계', icon: 'bi bi-graph-up' },
        { id: 'support', name: '고객지원', icon: 'bi bi-headset' }
      ],
      subMenus: {
        config: [
          { name: '기본 설정', path: '/admin/config/basic', icon: 'bi bi-sliders me-2' },
          { name: '사용자 관리', path: '/admin/config/users', icon: 'bi bi-people me-2' },
          { name: '권한 설정', path: '/admin/config/permissions', icon: 'bi bi-shield-lock me-2' },
          { name: '시스템 설정', path: '/admin/config/system', icon: 'bi bi-gear-wide-connected me-2' },
          { name: '휴일 관리', path: '/admin/config/holidays', icon: 'bi bi-calendar-event me-2' }
        ],
        vendor: [
          { name: '거래처 목록', path: '/admin/vendor/list', icon: 'bi bi-list-ul me-2' },
          // { name: '거래처 등록', path: '/admin/vendor/register', icon: 'bi bi-plus-circle me-2' },
          { name: '거래처 등급', path: '/admin/vendor/level', icon: 'bi bi-plus-circle me-2' },
          { name: '구매수량 제한', path: '/admin/vendor/purchase-limit', icon: 'bi bi-slash-circle me-2' },
          { name: '초대링크 관리', path: '/admin/invite-tokens', icon: 'bi bi-link-45deg me-2' },
          // 영업사원 파트너 — 2026-08-21 추가
          { name: '영업사원 파트너', path: '/admin/partner/list', icon: 'bi bi-person-badge me-2' },
          { name: '예상 정산 내역', path: '/admin/partner/settlements', icon: 'bi bi-calculator me-2' }
        ],
        seller: [
          { name: '입점사 목록', path: '/admin/seller/list', icon: 'bi bi-list-ul me-2' },
          { name: '입점신청 승인', path: '/admin/seller/signups', icon: 'bi bi-person-check me-2' },
          { name: '상품 승인', path: '/admin/seller/product-approval', icon: 'bi bi-patch-check me-2' },
          { name: '스토어 승인', path: '/admin/seller/store-approval', icon: 'bi bi-shop-window me-2' },
          { name: '광고 관리', path: '/admin/seller/ads', icon: 'bi bi-megaphone me-2' },
          { name: '입점사 문의', path: '/admin/seller/inquiries', icon: 'bi bi-chat-dots me-2' },
          { name: '입점사 공지', path: '/admin/seller/notices', icon: 'bi bi-megaphone me-2' },
          { name: '입점사 매출통계', path: '/admin/seller/sales-stats', icon: 'bi bi-graph-up-arrow me-2' },
          { name: '판매 정산', path: '/admin/seller/settlement', icon: 'bi bi-cash-stack me-2' }
        ],
        product: [
          { name: '제품 목록', path: '/admin/product/list', icon: 'bi bi-grid me-2' },
          { name: '제품 순서', path: '/admin/product/sort-order', icon: 'bi bi-sort-numeric-down me-2' },
          { name: '카테고리 관리', path: '/admin/product/categories', icon: 'bi bi-diagram-3 me-2' }
        ],
        inventory: [
          { name: '재고 현황', path: '/admin/inventory/status', icon: 'bi bi-clipboard-data me-2' },
          { name: '가나전산 연동(조회)', path: '/admin/inventory/gana', icon: 'bi bi-hdd-network me-2' }
        ],
        shoporders: [
          { name: '주문 목록', path: '/admin/shoporders', icon: 'bi bi-list-ul me-2' },
          { name: '신규 주문', path: '/admin/shoporders/new', icon: 'bi bi-plus-circle me-2' },
          { name: '배송 준비중', path: '/admin/shoporders/preparing', icon: 'bi bi-box-seam me-2' },
          { name: '배송중', path: '/admin/shoporders/shipping', icon: 'bi bi-truck me-2' },
          { name: '배송완료', path: '/admin/shoporders/delivered', icon: 'bi bi-check-circle me-2' },
          { name: '취소/반품/교환', path: '/admin/shoporders/cancelled', icon: 'bi bi-x-circle me-2' }
        ],
        order: [
          { name: '수주 관리', path: '/admin/business/list', icon: 'bi bi-journal-plus me-2' },
          { name: '배송 현황', path: '/admin/business/shipping', icon: 'bi bi-truck me-2' },
          { name: '견적 목록', path: '/admin/business/estimates', icon: 'bi bi-file-earmark-text me-2' },
          { name: '견적 등록', path: '/admin/business/create', icon: 'bi bi-plus-circle me-2' }
        ],
        shipping: [
          { name: '배송 목록', path: '/admin/shipping/list', icon: 'bi bi-truck me-2' },
          { name: '출고 목록', path: '/admin/shipping/dispatch', icon: 'bi bi-box-arrow-up-right me-2' },
          { name: '송장 등록', path: '/admin/shipping/invoice', icon: 'bi bi-receipt-cutoff me-2' },
          { name: '반품 관리', path: '/admin/shipping/returns', icon: 'bi bi-arrow-return-left me-2' },
          { name: '교환 관리', path: '/admin/shipping/exchanges', icon: 'bi bi-arrow-repeat me-2' }
        ],
        promotion: [
          { name: '쿠폰 관리', path: '/admin/promotion/coupons', icon: 'bi bi-ticket-perforated me-2' },
          { name: '프로모션 관리', path: '/admin/promotion/list', icon: 'bi bi-megaphone me-2' }
        ],
        design: [
          { name: '메인디자인 관리', path: '/admin/design/main', icon: 'bi bi-house me-2' },
          { name: '배너 관리', path: '/admin/design/banner', icon: 'bi bi-image me-2' },
          { name: '팝업 관리', path: '/admin/design/popup', icon: 'bi bi-window me-2' }
        ],
        payment: [
          { name: '정산 목록', path: '/admin/payment/settlements', icon: 'bi bi-cash-coin me-2' },
          { name: '외상 결제 현황', path: '/admin/payment/deferred', icon: 'bi bi-calendar-check me-2' },
          { name: '포인트 관리', path: '/admin/payment/point-management', icon: 'bi bi-star me-2' },
          { name: '포인트 내역', path: '/admin/payment/point-history', icon: 'bi bi-clock-history me-2' },
          { name: '포인트 설정', path: '/admin/payment/point-settings', icon: 'bi bi-gear me-2' }
        ],
        stats: [
          { name: '매출 통계', path: '/admin/stats/sales', icon: 'bi bi-bar-chart-line me-2' },
          { name: '주문 통계', path: '/admin/stats/statsorders', icon: 'bi bi-clipboard-data me-2' }
        ],
        support: [
          { name: '공지사항 관리', path: '/admin/support/notice', icon: 'bi bi-megaphone me-2' },
          { name: 'FAQ 관리', path: '/admin/support/faq', icon: 'bi bi-question-circle me-2' },
          { name: '1:1 문의 관리', path: '/admin/support/inquiry', icon: 'bi bi-chat-dots me-2' }
        ]
      }
    }
  },
  methods: {
    logout() {
      if (confirm('정말 로그아웃 하시겠습니까?')) {
        localStorage.removeItem('adminToken');
        sessionStorage.removeItem('adminToken');
        localStorage.removeItem('adminUser');
        localStorage.removeItem('admin_user');
        localStorage.removeItem('auth_token');
        sessionStorage.removeItem('auth_token');
        localStorage.removeItem('user_info');

        console.log('🔐 관리자 로그아웃 완료');
        alert('로그아웃되었습니다.');
        window.location.href = '/admin/login';
      }
    },
    setActiveMenu(menu) {
      this.activeMenu = menu.id;
      const subMenus = this.getSubMenus();
      if (subMenus.length > 0) {
        this.$router.push(subMenus[0].path);
      }
    },
    getSubMenus() {
      return this.subMenus[this.activeMenu] || [];
    },
    getActiveMenuName() {
      const menu = this.mainMenus.find(m => m.id === this.activeMenu);
      return menu ? menu.name : '';
    },
    getActiveMenuIcon() {
      const menu = this.mainMenus.find(m => m.id === this.activeMenu);
      return menu ? menu.icon : 'bi bi-folder';
    },
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;
    },
    updateTime() {
      const now = new Date();
      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      };
      this.currentTime = now.toLocaleString('ko-KR', options);
    }
  },
  created() {
    const path = this.$route.path;
    for (const menuId in this.subMenus) {
      const found = this.subMenus[menuId].some(subMenu => path.startsWith(subMenu.path));
      if (found) {
        this.activeMenu = menuId;
        break;
      }
    }
    this.updateTime();
    this.timeInterval = setInterval(this.updateTime, 1000);
  },
  beforeUnmount() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
  }
}
</script>

<style scoped>
/* Oracle ERP 스타일 관리자 레이아웃 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.oracle-admin-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f0f2f5;
  font-family: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* ==================== 헤더 스타일 ==================== */
.oracle-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* 유틸리티 바 */
.header-utility-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 24px;
  background: linear-gradient(135deg, #1a1f36 0%, #0f1225 100%);
  color: #a0aec0;
  font-size: 12px;
}

.utility-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.system-status {
  display: flex;
  align-items: center;
  gap: 6px;
}

.status-dot {
  font-size: 8px;
  color: #48bb78;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.utility-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.current-time,
.admin-name {
  display: flex;
  align-items: center;
  gap: 6px;
}

.current-time i,
.admin-name i {
  color: #0066cc;
}

.utility-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  color: #e2e8f0;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.utility-btn:hover {
  background: rgba(239, 68, 68, 0.2);
  border-color: #ef4444;
  color: #fca5a5;
}

/* 메인 헤더 */
.header-main {
  display: flex;
  align-items: center;
  padding: 0 24px;
  height: 60px;
  background: linear-gradient(135deg, #0066cc 0%, #004999 100%);
}

.header-brand {
  flex-shrink: 0;
}

.brand-link {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: white;
}

.brand-icon {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.brand-text {
  display: flex;
  flex-direction: column;
}

.brand-title {
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.brand-subtitle {
  font-size: 10px;
  opacity: 0.8;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* 메인 네비게이션 */
.header-nav {
  flex: 1;
  margin-left: 40px;
  overflow-x: auto;
}

.nav-items {
  display: flex;
  gap: 4px;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.2s;
  white-space: nowrap;
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.15);
  color: white;
}

.nav-item.active {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  box-shadow: inset 0 -2px 0 #00d4ff;
}

.nav-item i {
  font-size: 14px;
}

/* 모바일 메뉴 토글 */
.mobile-menu-toggle {
  display: none;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  border-radius: 6px;
  color: white;
  font-size: 20px;
  cursor: pointer;
  margin-left: auto;
}

/* 모바일 네비게이션 */
.mobile-nav {
  display: none;
  flex-direction: column;
  background: #004999;
  padding: 10px;
  gap: 4px;
}

.mobile-nav.show {
  display: flex;
}

.mobile-nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  font-size: 14px;
  border-radius: 6px;
  transition: all 0.2s;
}

.mobile-nav-item:hover,
.mobile-nav-item.active {
  background: rgba(255, 255, 255, 0.15);
  color: white;
}

/* ==================== 메인 컨테이너 ==================== */
.oracle-main-container {
  display: flex;
  flex: 1;
  min-height: calc(100vh - 200px);
}

/* ==================== 사이드바 ==================== */
.oracle-sidebar {
  width: 240px;
  background: #ffffff;
  border-right: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.sidebar-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}

.sidebar-header i {
  font-size: 18px;
  color: #0066cc;
}

.sidebar-nav {
  flex: 1;
  padding: 12px;
  overflow-y: auto;
}

.sidebar-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  color: #475569;
  text-decoration: none;
  font-size: 13px;
  border-radius: 8px;
  margin-bottom: 4px;
  transition: all 0.2s;
  position: relative;
}

.sidebar-link i:first-child {
  font-size: 16px;
  width: 20px;
  text-align: center;
  color: #64748b;
  transition: color 0.2s;
}

.sidebar-link span {
  flex: 1;
}

.sidebar-link .arrow-icon {
  font-size: 10px;
  opacity: 0;
  transition: all 0.2s;
  color: #94a3b8;
}

.sidebar-link:hover {
  background: #f1f5f9;
  color: #1e293b;
}

.sidebar-link:hover i:first-child {
  color: #0066cc;
}

.sidebar-link:hover .arrow-icon {
  opacity: 1;
  transform: translateX(3px);
}

.sidebar-link.active {
  background: linear-gradient(135deg, #0066cc 0%, #004999 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(0, 102, 204, 0.3);
}

.sidebar-link.active i:first-child {
  color: white;
}

.sidebar-link.active .arrow-icon {
  opacity: 1;
  color: rgba(255, 255, 255, 0.7);
}

.sidebar-footer {
  padding: 16px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}

.quick-stats {
  display: flex;
  justify-content: center;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #64748b;
}

.stat-item i {
  color: #0066cc;
}

/* ==================== 메인 콘텐츠 ==================== */
.oracle-content {
  flex: 1;
  min-width: 0;
  background: #f0f2f5;
  overflow-x: auto;
}

.content-wrapper {
  padding: 24px;
  min-height: 100%;
}

/* ==================== 푸터 ==================== */
.oracle-footer {
  background: linear-gradient(135deg, #1a1f36 0%, #0f1225 100%);
  border-top: 3px solid #0066cc;
  padding: 20px 24px;
  margin-top: auto;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.footer-left {
  display: flex;
  align-items: center;
}

.footer-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  color: white;
}

.footer-brand > i {
  font-size: 28px;
  color: #0066cc;
}

.footer-brand-text {
  display: flex;
  flex-direction: column;
}

.footer-title {
  font-size: 16px;
  font-weight: 600;
}

.footer-subtitle {
  font-size: 11px;
  color: #a0aec0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.footer-center {
  display: flex;
  align-items: center;
}

.footer-status {
  display: flex;
  gap: 12px;
}

.status-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  font-size: 12px;
  color: #a0aec0;
}

.status-badge.online {
  color: #48bb78;
}

.status-badge.online i {
  color: #48bb78;
}

.status-badge.version {
  background: linear-gradient(135deg, #0066cc 0%, #004999 100%);
  color: white;
  font-weight: 600;
}

.footer-right {
  text-align: right;
}

.footer-links {
  display: flex;
  gap: 16px;
  margin-bottom: 8px;
}

.footer-links a {
  color: #a0aec0;
  text-decoration: none;
  font-size: 12px;
  transition: color 0.2s;
}

.footer-links a:hover {
  color: #0066cc;
}

.copyright {
  font-size: 11px;
  color: #64748b;
  margin: 0;
}

/* ==================== 반응형 디자인 ==================== */
@media (max-width: 1200px) {
  .nav-item {
    padding: 10px 12px;
    font-size: 12px;
  }

  .nav-item span {
    display: none;
  }

  .nav-item i {
    font-size: 16px;
  }
}

@media (max-width: 992px) {
  .header-nav {
    display: none;
  }

  .mobile-menu-toggle {
    display: flex;
  }

  .oracle-sidebar {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 1001;
    transform: translateX(-100%);
    transition: transform 0.3s;
  }

  .oracle-sidebar.show {
    transform: translateX(0);
  }

  .oracle-content {
    margin-left: 0;
  }

  .footer-content {
    flex-direction: column;
    text-align: center;
  }

  .footer-right {
    text-align: center;
  }

  .footer-links {
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .header-utility-bar {
    padding: 6px 16px;
    font-size: 11px;
  }

  .utility-right {
    gap: 12px;
  }

  .current-time {
    display: none;
  }

  .header-main {
    padding: 0 16px;
    height: 56px;
  }

  .brand-text {
    display: none;
  }

  .content-wrapper {
    padding: 16px;
  }

  .oracle-footer {
    padding: 16px;
  }

  .footer-status {
    flex-wrap: wrap;
    justify-content: center;
  }
}

@media (max-width: 576px) {
  .utility-left {
    display: none;
  }

  .admin-name span {
    display: none;
  }

  .footer-brand-text {
    display: none;
  }
}

/* 스크롤바 스타일 */
.sidebar-nav::-webkit-scrollbar {
  width: 4px;
}

.sidebar-nav::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-nav::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}

.sidebar-nav::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* 네비게이션 스크롤바 숨기기 */
.header-nav::-webkit-scrollbar {
  display: none;
}

.header-nav {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
